export default __webpack_public_path__ + "e5cf5daed02f6bbbff0148902add1be7.jpg";